import { createRouter, createWebHistory } from "vue-router";

import DefaultHome from "../views/DefaultHome.vue";
import Login from "../views/login.vue";

function guardMyroute(to, from, next) {
  var isAuthenticated = false;
  //this is just an example. You will have to find a better or
  // centralised way to handle you localstorage data handling
  if (localStorage.getItem("email") != null) {
    //console.log(localStorage.getItem('email'))
    //console.log('user is here')
    isAuthenticated = true;
  } else {
    isAuthenticated = false;
  }

  if (isAuthenticated) {
    next(); // allow to enter route
  } else {
    next("/"); // go to '/login';
  }
}

const routes = [
  {
    path: "/dash",
    name: "default",
    component: DefaultHome,
    // beforeEnter : guardMyroute,
  },
  {
    path: "/",
    name: "home",
    component: () => import("../views/LandingPage.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/register.vue"),
  },
  {
    path: "/register_admin",
    name: "registerAdmin",
    component: () => import("../views/registerAdmin.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/parcel",
    name: "Parcel",

    component: () => import("../views/Parcel.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/parcel_all",
    name: "ParcelAll",

    component: () => import("../views/ParcelAll.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/parcel_add",
    name: "ParcelAdd",

    component: () => import("../views/ParcelAdd.vue"),
    beforeEnter: guardMyroute,
  },

  // {
  //   path: "/parcel_add",
  //   name: "ParcelAdd",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import( "../views/Parcel/parcelAdd.vue"),
  //   beforeEnter: guardMyroute,
  // },
  {
    path: "/u_parcel",
    name: "ParcelU",

    component: () => import("../views/ParcelU.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/manifest",
    name: "Manifest",

    component: () => import("../views/ManifestView.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/manifest_hub",
    name: "ManifestHub",

    component: () => import("../views/ManifestViewHub.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/manifest_detail/:parcelData",
    name: "ManifestDetail",
    props: true,

    component: () => import("../views/ManifestDetail_copy.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/manifest_detail_hub/:id",
    name: "ManifestDetailHub",

    component: () => import("../views/ManifestDetailHub.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/inspection",
    name: "Inspection",

    component: () => import("../views/Inspection.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/rack",
    name: "Rack",

    component: () => import("../views/Rack.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/settings",
    name: "Settings",

    component: () => import("../views/Settings.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/location",
    name: "Location",

    component: () => import("../views/Location.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/grn_pre",
    name: "PreGRN",

    component: () => import("../views/PreGRN.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/grn",
    name: "GRN",

    component: () => import("../views/GRN.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/test",
    name: "Test",

    component: () => import("../views/Test.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/type",
    name: "Type",

    component: () => import("../views/Type.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/hawb",
    name: "hawb",

    component: () => import("../views/HWAB.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/pickup",
    name: "pickup",

    component: () => import("../views/PickUp.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/rrwb",
    name: "rrwb",

    component: () => import("../views/RRWB.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/report_parcel",
    name: "ReportParcel",

    component: () => import("../views/ReportParcel.vue"),
    beforeEnter: guardMyroute,
  },
  {
    path: "/bag_box/:id",
    name: "BagBox",
    props: true,

    component: () => import("../views/BagBox.vue"),
    beforeEnter: guardMyroute,
  },

  // customer part
  {
    path: "/customer_dashboard",
    name: "CustomerDashboard",
    component: () =>
      import("@/views/CustomerProfilePage/CustomerDashboard.vue"),
    beforeEnter: guardMyroute,
  },
  // change-password for customer
  {
    path: "/change_password",
    name: "ChangePassword",
    component: () =>
      import("@/views/CustomerProfilePage/ChangePasswordCustomer.vue"),

    beforeEnter: guardMyroute,
  },

  {
    path: "/parcelInfo_withoutLogin",
    name: "ParcelInfowithoutLogin",
    props: true,

    component: () =>
      import("@/views/CustomerProfilePage/CustomerWithoutLogin.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
